<script setup lang="ts">
const logoImageUrl = useLogoUrl();
const appConfig = useRuntimeConfig().public;

const customerName = computed(() => appConfig.APP_CUSTOMER.name);
</script>

<template>
  <div class="flex items-center gap-2">
    <div class="min-w-12">
      <BaseButton type="icon" tag="nuxt-link" to="/" name="logo-link" link>
        <BaseImage class="baseHeader__logo" :src="logoImageUrl" fallback-src="/images/mock/logo.svg" alt="Logo" width="auto" :height="48" />
      </BaseButton>
    </div>

    <BaseButton type="icon" tag="nuxt-link" to="/" name="logo-link">
      <h1 class="text-base lg:text-2xl font-bold dark:text-white">
        {{ customerName }}
      </h1>
    </BaseButton>
  </div>
</template>
